"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@emotion/core");

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@umich-lib/styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/*
  Start with base styles and then bring in the
  styles specific to the size of the heading.
*/


var StyledHeading = (0, _styledBase["default"])("h1", {
  target: "e1tlxttt0",
  label: "StyledHeading"
})(function (_ref) {
  var size = _ref.size;
  return _styles.TYPOGRAPHY[size];
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFZc0IiLCJmaWxlIjoiLi4vc3JjL2luZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcblxuaW1wb3J0IHtcbiAgVFlQT0dSQVBIWVxufSBmcm9tICdAdW1pY2gtbGliL3N0eWxlcydcblxuLypcbiAgU3RhcnQgd2l0aCBiYXNlIHN0eWxlcyBhbmQgdGhlbiBicmluZyBpbiB0aGVcbiAgc3R5bGVzIHNwZWNpZmljIHRvIHRoZSBzaXplIG9mIHRoZSBoZWFkaW5nLlxuKi9cbmNvbnN0IFN0eWxlZEhlYWRpbmcgPSBzdHlsZWQuaDEoXG4gICh7IHNpemUgfSkgPT4gVFlQT0dSQVBIWVtzaXplXVxuKVxuXG4vKipcbiAgVXNlIGhlYWRpbmdzIGNvbnNpc3RlbnRseSB0byBjcmVhdGUgYSBjbGVhciBjb250ZW50IGhpZXJhcmNoeS5cbiovXG5jb25zdCBIZWFkaW5nID0gKHtcbiAgY2hpbGRyZW4sXG4gIGxldmVsLFxuICBjbGFzc05hbWUsXG4gIC4uLm90aGVyXG59KSA9PiAoXG4gIDxTdHlsZWRIZWFkaW5nXG4gICAgYXM9eydoJyArIGxldmVsfVxuICAgIGNsYXNzTmFtZT17Y2xhc3NOYW1lfVxuICAgIHsuLi5vdGhlcn1cbiAgPntjaGlsZHJlbn08L1N0eWxlZEhlYWRpbmc+XG4pXG5cbkhlYWRpbmcucHJvcFR5cGVzID0ge1xuICBjaGlsZHJlbjogUHJvcFR5cGVzLm5vZGUsXG4gIGNsYXNzTmFtZTogUHJvcFR5cGVzLnN0cmluZyxcbiAgLyoqXG4gICAgQXZvaWQgc2tpcHBpbmcgaGVhZGluZyBsZXZlbHM6IGFsd2F5cyBzdGFydCB0aGUgcGFnZSBmcm9tIGxldmVsIDEsIG5leHQgdXNlIGxldmVsIDIgYW5kIHNvIG9uLiBBdm9pZCB1c2luZyBsZXZlbCAxIG1vcmUgdGhhbiBvbmNlIG9uIGEgcGFnZS5cbiAgKi9cbiAgbGV2ZWw6IFByb3BUeXBlcy5vbmVPZihbMSwyLDMsNCw1LDZdKSxcbiAgc2l6ZTogUHJvcFR5cGVzLm9uZU9mKE9iamVjdC5rZXlzKFRZUE9HUkFQSFkpKS5pc1JlcXVpcmVkXG59O1xuXG5IZWFkaW5nLmRlZmF1bHRQcm9wcyA9IHtcbiAgbGV2ZWw6IDEsXG4gIHNpemU6ICdzbWFsbCdcbn07XG5cbmV4cG9ydCBkZWZhdWx0IEhlYWRpbmc7Il19 */");
/**
  Use headings consistently to create a clear content hierarchy.
*/

var Heading = function Heading(_ref2) {
  var children = _ref2.children,
      level = _ref2.level,
      className = _ref2.className,
      other = _objectWithoutProperties(_ref2, ["children", "level", "className"]);

  return (0, _core.jsx)(StyledHeading, _extends({
    as: 'h' + level,
    className: className
  }, other), children);
};

Heading.propTypes = {
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,

  /**
    Avoid skipping heading levels: always start the page from level 1, next use level 2 and so on. Avoid using level 1 more than once on a page.
  */
  level: _propTypes["default"].oneOf([1, 2, 3, 4, 5, 6]),
  size: _propTypes["default"].oneOf(Object.keys(_styles.TYPOGRAPHY)).isRequired
};
Heading.defaultProps = {
  level: 1,
  size: 'small'
};
var _default = Heading;
exports["default"] = _default;